import React, { useState } from "react";
import { FaMapMarkerAlt, FaFacebook, FaInstagram, FaWhatsapp, FaLinkedinIn, FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const [clickCount, setClickCount] = useState(0);

  const handlePolicyClick = (policyId) => {
    navigate("/termsPage");
    setTimeout(() => {
      const element = document.getElementById(policyId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 0.5);
  };

  const handleCopyrightClick = () => {
    setClickCount((prevCount) => prevCount + 1);
    if (clickCount + 1 === 7) {
      navigate("/loginFa");
    }
  };

  return (
    <div>
      <footer className="bg-body-tertiary text-center text-lg-start">
        <div className="container-fluid">
          <hr className="mt-5 mb-5" style={{ border: "2px solid #000" }} />

          {/* Footer Grid */}
          <div className="row justify-content-center text-center">
            {/* Column 1 - About Us */}
            <div className="col-lg-4 col-md-4 mb-4">
              <h5 className="text-uppercase ">About Us</h5>
              <p style={{
                userSelect: "none", 
                pointerEvents: "none",
              }}>
               The Dry Fruit Shop is a harmonious collaboration between two distinguished and registered firms M.Y Bhat & Son’s and Y.R Traders united by a shared passion for quality, authenticity, and excellence. Rooted in the heart of Srinagar, both firms bring decades of experience in offering premium dry fruits and nuts sourced from Kashmir, as well as a wide selection of other finest dry fruits from different parts of the world. Along with our high-quality products, we specialize in creating beautifully curated luxury hampers and gift baskets, including dry fruit hampers, chocolate baskets, and toffee assortments for engagements, nikkah ceremonies, catchments, weddings, and special functions. With over 20,000+ custom hampers successfully crafted, we take pride in delivering warm, thoughtful, and elegant gifting experiences that carry the purity, taste, and charm of our valley in every detail.
              </p>
            </div>

            {/* Column 2 - Contact Us */}
            <div className="col-lg-4 col-md-4 mb-4">
              <h5 className="text-uppercase">Contact Us</h5>
              <div><FaPhoneAlt /> +918899090309</div>
             
            </div>

            {/* Column 3 - Follow Us */}
            <div className="col-lg-4 col-md-4 mb-4">
              <h5 className="text-uppercase">Follow Us</h5>
              <a href="https://www.facebook.com/profile.php?id=100067390846680&mibextid=ZbWKwL" className="me-4">
                <FaFacebook size={30} />
              </a>
              <a href="https://www.instagram.com/the_dry_fruit_shop" className="me-4">
                <FaInstagram size={30} />
              </a>
              <a href="https://wa.me/message/RGO2YK2UUANFO1">
                <FaWhatsapp size={30} />
              </a>
            </div>
          </div>

          {/* Second Row */}
          <div className="row justify-content-center text-center">
            {/* Column 1 - Location */}
            <div className="col-lg-4 col-md-4 mb-4">
              <h5 className="text-uppercase">Location</h5>
              <a href="https://maps.app.goo.gl/sd12fCBbBEVEjdx6A">
                <FaMapMarkerAlt size={30} /> Maharaja Bazar, Srinagar, Kashmir
              </a>
            </div>

            {/* Column 2 - Terms & Policies */}
            <div className="col-lg-4 col-md-4 mb-4">
              <h5 className="text-uppercase">Terms & Policies</h5>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("privacy-policy")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Privacy Policy
              </span>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("terms-of-service")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Terms of Service (ToS)
              </span>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("payment-terms")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Payment Terms
              </span>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("return-refund")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Return & Refund Policy
              </span>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("shipping-policy")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Shipping Policy
              </span>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("cancellation-policy")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Cancellation Policy
              </span>
              <span 
                className="d-block mt-2" 
                onClick={() => handlePolicyClick("intellectual-property")} 
                style={{ color: '#1F75FE', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Intellectual Property Policy
              </span>
            </div>

            {/* Column 3 - Developed By */}
            <div className="col-lg-4 col-md-4 mb-4">
              <h5 className="text-uppercase">Developed By</h5>
              <a href="https://www.linkedin.com/in/hashim-yousuf-6b8196215/" className="text-center"> 
                <FaLinkedinIn size={30} /> Hashim Bhat
              </a>
            </div>
          </div>
        </div>
        <div 
          className="text-center p-3 mt-3"
          onClick={handleCopyrightClick}
          style={{ userSelect: "none" }}
        >
          © 2026 Copyright: The Dry Fruit Shop
        </div>
      </footer>
    </div>
  );
}
